<template>
  <div>
    <HeaderBar :title="hTitle" />
    <div class="my-4 text-xl">
      If you have chosen Inhouse Financing, this means you have chosen to settle
      the Total Contract Price and other fees under Moldex’s Inhouse payment
      terms.
    </div>
    <div class="my-4 text-xl">
      Your Total Contract Price may be divided in two stages depending on your
      chosen and approved payment terms. You will first need to settle your Down
      Payment which will start 30 days after settling your Reservation Fee
      (unless otherwise stated). Next, your Monthly Amortization will commence
      30 days after you’ve settled your full down payment.
    </div>
    <div class="my-4 text-xl">
      This will vary depending on the approved and signed payment terms.
    </div>
  </div>
</template>

<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  props: ["hTitle"],
  components: { HeaderBar },
};
</script>